export const braintreeInitialState = {
  clientToken: null,
  status: "pending", // pending, ready, error
  error: null,
  paypalData: null
};

export default braintreeInitialState;
